<template>
    <vue-multiselect-original
        :ref="id"
        selectLabel=""
        selectGroupLabel=""
        selectedLabel=""
        deselectLabel=""
        deselectGroupLabel=""
        :disabled="disabled"
        v-bind="$attrs"
        v-on="listeners"
        class="position-relative">
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope"/>
        </template>
    </vue-multiselect-original>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {getRandomId} from '@/utils'

export default {
    // inheritAttrs: false,
    props: {
        custom: {
            type: Object // extend original multiselect behaviour
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        'vue-multiselect-original': Multiselect
    },
    data() {
        return {
            id: this.$attrs.id || getRandomId('multiselect')
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                open: () => this.onOpen(),
                close: () => this.onClose()
            }
        }
    },
    methods: {
        onOpen() {
            if (this.custom) {
                if (_.isArray(this.custom.disableScrollSelectors)) {
                    this.custom.disableScrollSelectors.forEach(id => {
                        const el = document.querySelector(id)
                        if (el) {
                            el.style = 'overflow: hidden !important;'
                        }
                    })
                }

                if (this.custom.reposition) {
                    if (this.$attrs.id) {
                        const {top, height, width, left} = this.$el.getBoundingClientRect()
                        const ref = this.$refs[this.$attrs.id]
                        if (ref) {
                            ref.$refs.list.style.width = `${width}px`
                            ref.$refs.list.style.position = 'fixed'
                            ref.$refs.list.style.bottom = 'auto'
                            ref.$refs.list.style.top = `${top + height}px`
                            ref.$refs.list.style.left = `${left}px`
                        }
                    }
                }
            }
            if (typeof this.$listeners.open === 'function') {
                this.$listeners.open()
            }
        },

        onClose() {
            if (this.custom) {
                if (_.isArray(this.custom.disableScrollSelectors)) {
                    this.custom.disableScrollSelectors.forEach(id => {
                        const el = document.querySelector(id)
                        if (el) {
                            el.style = 'overflow: auto !important;'
                        }
                    })
                }
            }
            if (typeof this.$listeners.close === 'function') {
                this.$listeners.close()
            }
        }
    },
    mounted() {
        if (this.autofocus && this.$refs[this.id] && this.$refs[this.id].$el) {
            this.$refs[this.id].$el.focus()
        }
    }
}
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';

$sm-height: 31px;
$md-height: 38px;

// SMALL VERSION (DEFAULT)
.multiselect,
.multiselect__tags {
    min-height: $sm-height;
    box-sizing: border-box;
    border-radius: 3.2px;
    border-color: rgb(206, 212, 218);
}

.multiselect__select {
    height: $sm-height;
    padding-top: 6px;
}

.multiselect__input:hover,
.multiselect__single:hover.is-invalid,
.multiselect__content-wrapper{
    border-color: rgb(206, 212, 218);
}

.multiselect__input:focus,
.multiselect__single:focus {
    border-color: rgb(206, 212, 218);
    outline: none;
}
.multiselect__tags {
    padding-top: 3px;
}
.multiselect__single,
.multiselect__input {
    margin-bottom: 0;
    padding-top: 1px;
}

.multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 3px;
}

.multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
}

.multiselect.is-invalid {
    border: 1px solid red;
}

.multiselect__tag,
.multiselect__option--highlight,
.multiselect__option--highlight:after {
    background: $color-purple-light;
    margin-bottom: 0;
}

.multiselect__tag-icon:after {
    color: white;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
    background: $color-purple-primary;
}

.multiselect__spinner {
    right: 2px;
    top: 4px;
    width: 40px;
    height: 24px;
    background: #fff;
    display: block;
}

.multiselect__spinner:before,
.multiselect__spinner:after {
    border-color: $color-purple-light transparent transparent;
}

.multiselect__single {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.multiselect__option {
    display: block;
    padding: 8px;
    min-height: $sm-height;
    line-height: 16px;
}

.multiselect__option:after {
    top: 0;
    right: 0;
    line-height: $sm-height;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px;
}

// MEDIUM VERSION
.multiselect-md {
    min-height: $md-height !important;

    .multiselect, .multiselect__tags, .multiselect__select {
        min-height: $md-height !important;
    }

    .multiselect__select {
        padding-top: 5px;
    }

    .multiselect__tags {
        padding-top: 8px;
    }

    .multiselect__single {
        padding-top: 0;
    }

    .multiselect, .multiselect__input, .multiselect__single {
        font-size: 16px;
    }
    .multiselect__spinner {
        right: 1px;
        top: 6px;
        width: 40px;
        height: 28px;
        background: #fff;
        display: block;
    }
    .multiselect__option {
        padding: 8px;
        min-height: $md-height;
        line-height: 18px;
    }

    .multiselect__option:after {
        top: 0;
        right: 0;
        line-height: $md-height;
        padding-right: 12px;
        padding-left: 20px;
        font-size: 13px;
    }

    .multiselect__placeholder {
        padding-top: 1px;
    }
}

</style>
